import { IconButton, InputAdornment, Popover, TextField, Typography } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import React, { FC, useState } from 'react';

import styles from './styles';

type TextFieldType = {
  id?: string;
  text: string;
  value?: string;
  tooltip?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  disabled?: boolean;
};

const TextFieldItem: FC<TextFieldType> = (props) => {
  const classes = styles();

  const [anchorEl, setAnchorEl] = useState(null);

  const showInfoSnipped = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const hideInfoSnipped = (_event) => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <TextField
      className={classes.input}
      margin="dense"
      key={props.id}
      label={props.text}
      disabled={props.disabled}
      // InputLabelProps={{style: {right: '22px'}}}
      InputLabelProps={{ style: { fontSize: 13, right: 22, padding: 0 } }}
      multiline={true}
      rows={1}
      // size={"small"}
      onChange={props.onChange}
      fullWidth={false}
      value={props.value}
      InputProps={
        props.tooltip
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    // onClick={hideInfoSnipped}
                    onMouseDown={showInfoSnipped}
                    edge="end"
                  >
                    <HelpIcon />
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={hideInfoSnipped}
                      anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'center',
                        horizontal: 'left',
                      }}
                    >
                      <Typography style={{ padding: 10 }}>{props.tooltip}</Typography>
                    </Popover>
                  </IconButton>
                </InputAdornment>
              ),
            }
          : {}
      }
    />
  );
};

export default React.memo(TextFieldItem);
